module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.0.0 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/actionsheet.html"
    }
  }, [_vm._v("Actionsheet")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] 更新到 vue@2.0，使用 `v-model` 而不是`:show.sync`进行显示属性绑定")]), _vm._v(" "), _c('li', [_vm._v("[feature] 添加属性 `close-on-clicking-mask`, 适用于强制选择的场景")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] 使用 `v-model` 而不是`:show.sync`进行显示属性绑定")]), _vm._v(" "), _c('li', [_vm._v("[todo] 修复动画")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/button-tab.html"
    }
  }, [_vm._v("ButtonTab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 去除 Android 下点击可能出现的蓝色边框")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/checker.html"
    }
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持Object类型的值 #705")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] 默认不显示错误，你可以监听on-error事件结合slot进行处理和显示")]), _vm._v(" "), _c('li', [_vm._v("[feature] 添加插槽 footer、after-title")]), _vm._v(" "), _c('li', [_vm._v("[change] 如果已经达到max上限，没有选中的选项将不能选择，因此不再和之前版本一样会出现最多可选max个的error信息")]), _vm._v(" "), _c('li', [_vm._v("[change] 默认 required 值为false, 与html规范一致")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/color-picker.html"
    }
  }, [_vm._v("ColorPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[deprecated] 废弃，当前版本后不再继续维护")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/countdown.html"
    }
  }, [_vm._v("Countdown")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[deprecated] 下一版本开始不再维护")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/countup.html"
    }
  }, [_vm._v("Countup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 prop:`start`, 现在你可以手动开始计数了")]), _vm._v(" "), _c('li', [_vm._v("[change] 更新依赖`countup`为`countup.js`")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/form-preview.html"
    }
  }, [_vm._v("FormPreview")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 增加`form-preview`组件")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/load-more.html"
    }
  }, [_vm._v("LoadMore")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 增加`load-more`组件")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popover.html"
    }
  }, [_vm._v("Popover")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[todo] 当切换i18n语言时，位置不正确")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/toast.html"
    }
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] 使用 `v-model` 而不是`:show.sync`进行显示属性绑定")]), _vm._v(" "), _c('li', [_vm._v("[change] 默认不显示遮罩")]), _vm._v(" "), _c('li', [_vm._v("[feature] 添加 isShowMask 属性")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 `novalidate` 及 `iconType` 可以禁用组件验证，手动显示 error 或者 success 样式")]), _vm._v(" "), _c('li', [_vm._v("[feature] `is-type` 支持传入函数")]), _vm._v(" "), _c('li', [_vm._v("[change] 受限于vue2不能动态设置type，目前`type`支持 text password number email")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-number.html"
    }
  }, [_vm._v("XNumber")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] fillable 值默认为false, 稍微保护一下不小心商城的后端接口没有做好数据校验的用户，导致用户粘贴负数还提交正确")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e913072", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-3e913072"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.0.0-194.vue
// module id = 2174
// module chunks = 381